import React from 'react'
import star from '../../images/star.svg'

const MarqueeSec = (props) => {
    const texts = [
        "Let's Build Something Amazing",
        "Crafting digital experiences that matter.",
        "Turning ideas into reality — together."
    ];

    return (
        <div className="digital-marque-sec">
            <div className="digital-marque">
                <div className="seamless-marquee-track">
                    <div className="marquee-content-wrapper">
                        {texts.map((text, index) => (
                            <span key={`first-${index}`} className="marquee-item">
                                <span className="marquee-text">{text}</span>
                                <i className="marquee-icon"><img src={star} alt="star" /></i>
                            </span>
                        ))}
                    </div>
                    {/* Duplicate for seamless loop */}
                    <div className="marquee-content-wrapper" aria-hidden="true">
                        {texts.map((text, index) => (
                            <span key={`second-${index}`} className="marquee-item">
                                <span className="marquee-text">{text}</span>
                                <i className="marquee-icon"><img src={star} alt="star" /></i>
                            </span>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MarqueeSec;